// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"campaigns___wrapper___1kRZe"};